
import API from '@/api/config'
import { getStore,customSetStorage, customGetStorage} from '@/utils/utils'

const actions = {
    // 系统年份

    getSystemYear() {
        return new Promise((resolve, reject) => {
            let data = getStore("WishYear");
            if (data) {
                resolve(data)
            }
        })
    }
}

export default {
    namespaced: true,
    actions
}